/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Busy_Active_Bee_ProcessInputs */

const en_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

const id_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memproses`)
};

const ms_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang memproses`)
};

const ca_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processant`)
};

const cs_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probíhá zpracování`)
};

const da_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandler`)
};

const de_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird verarbeitet`)
};

const et_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Töötlemine`)
};

const es_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando`)
};

const fr_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours de traitement`)
};

const hr_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrađuje se`)
};

const it_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In elaborazione`)
};

const lv_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiek apstrāde`)
};

const lt_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyksta apdorojimas`)
};

const hu_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feldolgozás`)
};

const nl_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerken`)
};

const nb_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandler`)
};

const pl_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie`)
};

const pt_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando`)
};

const ro_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În curs de prelucrare`)
};

const sk_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spracováva sa`)
};

const sl_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obdelava`)
};

const fi_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsitellään`)
};

const sv_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbetar`)
};

const vi_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xử lý`)
};

const tr_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşleniyor`)
};

const el_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Υπό επεξεργασία`)
};

const bg_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработване`)
};

const ru_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка`)
};

const sr_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обрађује се`)
};

const uk_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обробка`)
};

const ka_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მუშავდება`)
};

const hi_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोसेसिंग`)
};

const th_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังประมวลผล`)
};

const ko_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`처리`)
};

const zh_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理`)
};

const zh_tw_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`處理中`)
};

const ja_busy_active_bee_process = /** @type {(inputs: Busy_Active_Bee_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理中`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Busy_Active_Bee_ProcessInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const busy_active_bee_process = /** @type {((inputs?: Busy_Active_Bee_ProcessInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Busy_Active_Bee_ProcessInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_busy_active_bee_process(inputs)
	if (locale === "ms") return ms_busy_active_bee_process(inputs)
	if (locale === "ca") return ca_busy_active_bee_process(inputs)
	if (locale === "cs") return cs_busy_active_bee_process(inputs)
	if (locale === "da") return da_busy_active_bee_process(inputs)
	if (locale === "de") return de_busy_active_bee_process(inputs)
	if (locale === "et") return et_busy_active_bee_process(inputs)
	if (locale === "es") return es_busy_active_bee_process(inputs)
	if (locale === "fr") return fr_busy_active_bee_process(inputs)
	if (locale === "hr") return hr_busy_active_bee_process(inputs)
	if (locale === "it") return it_busy_active_bee_process(inputs)
	if (locale === "lv") return lv_busy_active_bee_process(inputs)
	if (locale === "lt") return lt_busy_active_bee_process(inputs)
	if (locale === "hu") return hu_busy_active_bee_process(inputs)
	if (locale === "nl") return nl_busy_active_bee_process(inputs)
	if (locale === "nb") return nb_busy_active_bee_process(inputs)
	if (locale === "pl") return pl_busy_active_bee_process(inputs)
	if (locale === "pt") return pt_busy_active_bee_process(inputs)
	if (locale === "ro") return ro_busy_active_bee_process(inputs)
	if (locale === "sk") return sk_busy_active_bee_process(inputs)
	if (locale === "sl") return sl_busy_active_bee_process(inputs)
	if (locale === "fi") return fi_busy_active_bee_process(inputs)
	if (locale === "sv") return sv_busy_active_bee_process(inputs)
	if (locale === "vi") return vi_busy_active_bee_process(inputs)
	if (locale === "tr") return tr_busy_active_bee_process(inputs)
	if (locale === "el") return el_busy_active_bee_process(inputs)
	if (locale === "bg") return bg_busy_active_bee_process(inputs)
	if (locale === "ru") return ru_busy_active_bee_process(inputs)
	if (locale === "sr") return sr_busy_active_bee_process(inputs)
	if (locale === "uk") return uk_busy_active_bee_process(inputs)
	if (locale === "ka") return ka_busy_active_bee_process(inputs)
	if (locale === "hi") return hi_busy_active_bee_process(inputs)
	if (locale === "th") return th_busy_active_bee_process(inputs)
	if (locale === "ko") return ko_busy_active_bee_process(inputs)
	if (locale === "zh") return zh_busy_active_bee_process(inputs)
	if (locale === "zh-tw") return zh_tw_busy_active_bee_process(inputs)
	if (locale === "ja") return ja_busy_active_bee_process(inputs)
	return en_busy_active_bee_process(inputs)
});